import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginComponent} from './login/login.component';
import {ToastModule} from 'primeng/toast';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ToastComponent} from './toast/toast.component';
import {MessageService} from 'primeng/api';

@NgModule({
  declarations: [LoginComponent, ToastComponent],
  imports: [CommonModule, ToastModule, FormsModule, ReactiveFormsModule],
  exports: [LoginComponent, ToastComponent],
  providers: [MessageService],
})
export class UtilsModule {}
